import * as React from "react";
import {CSSTransition, TransitionGroup} from "react-transition-group";

export const CssTransition = (
    {next, classNames} : {
        next: () => JSX.Element,
        classNames: string,
    }
) => (
    <TransitionGroup appear>
        <CSSTransition timeout={3000} classNames={classNames} appear>
            {next()}
        </CSSTransition>
    </TransitionGroup>
);
